import Box from '@material-ui/core/Box';
import React from 'react';
import { DoorHistoryFragment } from '../../../../../queries';
import DoorHistoryDetailDialog from '../DoorHistoryDetailDialog';
import StandardGridItem from './StandardGridItem';
import { Grid } from '@material-ui/core';
import HistoryEventTypes from '../../../../../constants/HistoryEventTypes';

interface AdditionalInfo {
  packId?: string;
  packName?: string;
}

interface Props {
  open: boolean;
  onClose: () => void;
  history: DoorHistoryFragment;
}

interface DetailDialogProps {
  history: DoorHistoryFragment;
  isPass: boolean;
}

function DetailDialog({ history }: DetailDialogProps) {
  if (!history.additionalInfoJson) {
    return <></>;
  }

  const additionalInfo = JSON.parse(history.additionalInfoJson) as AdditionalInfo;
  return (
    <Box pt={1} pb={1}>
      <Grid container spacing={3}>
        <StandardGridItem title={'Pack Id'} value={additionalInfo.packId} minWidth={6} />
        <StandardGridItem title={'Pack name'} value={additionalInfo.packName} minWidth={6} />
      </Grid>
    </Box>
  );
}

export default function PackAppliedToDoorDetailDialog({ open, onClose, history }: Props) {
  const isPass = history.historyEventType.code === HistoryEventTypes.DoorInspectionPassed;
  return (
    <DoorHistoryDetailDialog open={open} onClose={onClose} history={history} actorName={'Added by'}>
      <DetailDialog history={history} isPass={isPass} />
    </DoorHistoryDetailDialog>
  );
}
